import { defineMessages } from 'react-intl';

export const featureGateMessages = defineMessages({
  additionalQuestions: {
    id: 'FeatureGate.additionalQuestions',
    defaultMessage: 'Additional questions are available on Growth and Scale plans.',
  },
  audiences: {
    id: 'FeatureGate.audiences',
    defaultMessage: 'Audience targeting is available on Growth and Scale plans.',
  },
  autoTagging: {
    id: 'FeatureGate.autoTagging',
    defaultMessage: 'Auto-tagging is available on the Scale plan.',
  },
  autoTranslate: {
    id: 'FeatureGate.autoTranslate',
    defaultMessage: 'Auto-translate is available on Growth and Scale plans.',
  },
  branchingLogic: {
    id: 'FeatureGate.branchingLogic',
    defaultMessage: 'Branching logic is available on Growth and Scale plans.',
  },
  customRetention: {
    id: 'FeatureGate.customRetention',
    defaultMessage: 'Custom data retention is available on the Scale plan.',
  },
  dynamicFollowup: {
    id: 'FeatureGate.dynamicFollowup',
    defaultMessage: 'Dynamic follow-up is available on Growth and Scale plans.',
  },
  integrations: {
    id: 'FeatureGate.integrations',
    defaultMessage: 'Integrations are available on Growth and Scale plans.',
  },
  api: {
    id: 'FeatureGate.api',
    defaultMessage: 'API access is available on Growth and Scale plans.',
  },
  auditLog: {
    id: 'FeatureGate.auditLog',
    defaultMessage: 'Audit log is available on the Scale plan.',
  },
  sms: {
    id: 'FeatureGate.sms',
    defaultMessage: 'SMS surveys are available on the Scale plan.',
  },
  sso: {
    id: 'FeatureGate.sso',
    defaultMessage: 'SSO is available on the Scale plan.',
  },
  webTargeting: {
    id: 'FeatureGate.webTargeting',
    defaultMessage: 'Web targeting is available on Growth and Scale plans.',
  },
  upgradeGrowth: {
    id: 'FeatureGate.UpgradeTo.growth',
    defaultMessage: 'Upgrade to Growth',
  },
  upgradeScale: {
    id: 'FeatureGate.UpgradeTo.scale',
    defaultMessage: 'Upgrade to Scale',
  },
  upgradeStarter: {
    id: 'FeatureGate.UpgradeTo.starter',
    defaultMessage: 'View plans',
  },
  featureFallback: {
    id: 'FeatureGate.Fallback',
    defaultMessage: 'This feature is not included in your current plan.',
  },
});

export const featureMessageByKey = {
  additionalQuestions: featureGateMessages.additionalQuestions,
  audiences: featureGateMessages.audiences,
  autoTagging: featureGateMessages.autoTagging,
  autoTranslate: featureGateMessages.autoTranslate,
  branchingLogic: featureGateMessages.branchingLogic,
  customRetention: featureGateMessages.customRetention,
  dynamicFollowup: featureGateMessages.dynamicFollowup,
  integrations: featureGateMessages.integrations,
  api: featureGateMessages.api,
  auditLog: featureGateMessages.auditLog,
  sms: featureGateMessages.sms,
  sso: featureGateMessages.sso,
  webTargeting: featureGateMessages.webTargeting,
};

export const upgradeMessageByTier = {
  growth: featureGateMessages.upgradeGrowth,
  scale: featureGateMessages.upgradeScale,
  starter: featureGateMessages.upgradeStarter,
};
